import { render, staticRenderFns } from "./EmojiCharacteristicBar.vue?vue&type=template&id=12fd88d0"
import script from "./emoji-characteristic-bar.ts?vue&type=script&lang=ts&external"
export * from "./emoji-characteristic-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./emoji-characteristic-bar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports